import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { RouteHandlerService } from '../services/route-handler.service';

export const subdomainMatchGuard: CanMatchFn = () => {
    return inject(RouteHandlerService).isTicketsHost();
};
